export default __webpack_public_path__ + "static/media/our-partner-new-3.51b9b82f.jpg";